import React from 'react';
import { BUCKETS } from '../theme';
import type { OrderBucketKey } from '../types';

const BucketChip: React.FC<{ bucket: OrderBucketKey; className?: string; label?: string }> = ({ bucket, className = '', label }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${BUCKETS[bucket].chip} ${className}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${BUCKETS[bucket].dot}`} />
    {label ?? BUCKETS[bucket].label}
  </span>
);

export default BucketChip;
